function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import { validateNumbers } from 'invision-core/src/utilities/input.helper';
import CustomerCareLocaleKeys from '../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { NUMBERS_ONLY_OR_BLANK } from 'invision-core/src/constants/validation.constants';
var TaxExemptionDetailsController = /*#__PURE__*/function () {
  function TaxExemptionDetailsController($scope) {
    _classCallCheck(this, TaxExemptionDetailsController);
    Object.assign(this, {
      $scope: $scope,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      NUMBERS_ONLY_OR_BLANK: NUMBERS_ONLY_OR_BLANK,
      emptyRow: {
        taxLevelCode: null,
        taxExemptionType: null,
        taxAssociationCode: null,
        addressStateProvinceRegionCode: null,
        overrideValue: null
      },
      validateNumbers: validateNumbers
    });
  }
  return _createClass(TaxExemptionDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.onSelectionChangedHandler = this.onSelectionChanged() || angular.noop;
      this.$scope.$watch(function () {
        return _this.ngModel.$modelValue;
      }, function () {
        _this.initializeFieldModel();
      });
      this.initializeValidator();
    }
  }, {
    key: "initializeFieldModel",
    value: function initializeFieldModel() {
      if (this.ngModel.$modelValue) {
        var viewValue = this.ngModel.$modelValue.length !== 0 ? this.ngModel.$modelValue : [clone(this.emptyRow)];
        this.ngModel.$setViewValue(viewValue);
      }
    }
  }, {
    key: "initializeValidator",
    value: function initializeValidator() {
      var _this2 = this;
      this.ngModel.$validators.multiDropdownValid = function (modelValue) {
        return _this2.validateUnfinishedRows(modelValue) && _this2.validateDuplicateRows(modelValue);
      };
    }
  }, {
    key: "validateUnfinishedRows",
    value: function validateUnfinishedRows(modelValue) {
      var _iterator = _createForOfIteratorHelper(modelValue),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (this.rowNotComplete(item)) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }
  }, {
    key: "validateDuplicateRows",
    value: function validateDuplicateRows(modelValue) {
      var _iterator2 = _createForOfIteratorHelper(modelValue),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          if (this.rowNotEmpty(item) && this.duplicateRowExists(item)) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return true;
    }
  }, {
    key: "rowNotComplete",
    value: function rowNotComplete(dropdownOption) {
      if (!dropdownOption.taxLevelCode && !dropdownOption.taxExemptionType) {
        return false;
      } else {
        return !dropdownOption.taxLevelCode || !dropdownOption.taxExemptionType;
      }
    }
  }, {
    key: "rowNotEmpty",
    value: function rowNotEmpty(row) {
      return row.taxLevelCode !== null && row.taxExemptionType !== null;
    }
  }, {
    key: "taxTypeAndTaxLevelBothHaveValue",
    value: function taxTypeAndTaxLevelBothHaveValue(dropdownOption) {
      return dropdownOption.taxLevelCode && dropdownOption.taxExemptionType;
    }
  }, {
    key: "taxTypeAndTaxLevelCodeHaveNoValue",
    value: function taxTypeAndTaxLevelCodeHaveNoValue(dropdownOption) {
      return !dropdownOption.taxLevelCode && !dropdownOption.taxExemptionType;
    }
  }, {
    key: "rowNotCompleteForTaxExemption",
    value: function rowNotCompleteForTaxExemption(dropdownOption) {
      if (this.formCtrl.$submitted) {
        if (this.taxTypeAndTaxLevelCodeHaveNoValue(dropdownOption)) {
          return false;
        } else {
          return !dropdownOption.taxExemptionType;
        }
      } else {
        return false;
      }
    }
  }, {
    key: "rowNotCompleteForTaxLevel",
    value: function rowNotCompleteForTaxLevel(dropdownOption) {
      if (this.formCtrl.$submitted) {
        if (this.taxTypeAndTaxLevelCodeHaveNoValue(dropdownOption)) {
          return false;
        } else {
          return !dropdownOption.taxLevelCode;
        }
      } else {
        return false;
      }
    }
  }, {
    key: "duplicateRowExists",
    value: function duplicateRowExists(dropdownOption) {
      var _this3 = this;
      var duplicateRowCount = this.ngModel.$viewValue.filter(function (row) {
        if (_this3.taxTypeAndTaxLevelBothHaveValue(row) && _this3.taxTypeAndTaxLevelBothHaveValue(dropdownOption)) {
          return row.taxLevelCode.Id === dropdownOption.taxLevelCode.Id && row.taxExemptionType.Id === dropdownOption.taxExemptionType.Id && (row.taxAssociationCode && row.taxAssociationCode.Id) === (dropdownOption.taxAssociationCode && dropdownOption.taxAssociationCode.Id) && (row.addressStateProvinceRegionCode && row.addressStateProvinceRegionCode.Id) === (dropdownOption.addressStateProvinceRegionCode && dropdownOption.addressStateProvinceRegionCode.Id);
        }
        return false;
      });
      if (duplicateRowCount.length > 1) {
        this.addFlagForDuplicateCheck(duplicateRowCount);
      }
      return duplicateRowCount.length > 1;
    }
  }, {
    key: "addFlagForDuplicateCheck",
    value: function addFlagForDuplicateCheck(duplicateRows) {
      duplicateRows.forEach(function (row, index) {
        if (index === 0) {
          row.firstDuplicateRow = true;
        } else {
          row.firstDuplicateRow = false;
        }
      });
    }
  }, {
    key: "validateModel",
    value: function validateModel(dropdownOption) {
      this.ngModel.$validate();
      this.onSelectionChangedHandler();
      if (dropdownOption && !this.taxTypeAndTaxLevelBothHaveValue(dropdownOption)) {
        dropdownOption.addressStateProvinceRegionCode = null;
        dropdownOption.overrideValue = null;
        dropdownOption.taxAssociationCode = null;
      }
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(dropdownOption) {
      if (this.shouldShowDuplicateError(dropdownOption)) {
        return i18n.translate(this.CustomerCareLocaleKeys.TAX_LABELS.DROPDOWN_SELECT_VALIDATIONS.ROW_DUPLICATE);
      }
      return '';
    }
  }, {
    key: "addAdditionalItem",
    value: function addAdditionalItem() {
      var ngModelValue = this.ngModel.$viewValue;
      ngModelValue.push(clone(this.emptyRow));
      this.ngModel.$setViewValue(ngModelValue);
      this.validateModel();
    }
  }, {
    key: "onDeleteClick",
    value: function onDeleteClick(index) {
      var ngModelValue = this.ngModel.$viewValue;
      ngModelValue.splice(index, 1);
      this.ngModel.$setViewValue(ngModelValue);
      this.validateModel();
    }
  }, {
    key: "shouldHideDeleteButton",
    value: function shouldHideDeleteButton(index) {
      return index === this.ngModel.$viewValue.length;
    }
  }, {
    key: "shouldShowDuplicateError",
    value: function shouldShowDuplicateError(dropdownOption) {
      if (this.formCtrl.$submitted) {
        return this.duplicateRowExists(dropdownOption);
      }
    }
  }, {
    key: "removeIdentityVerification",
    value: function removeIdentityVerification(index) {
      this.ngModel.$viewValue.splice(index, 1);
      this.validateModel();
    }
  }, {
    key: "fieldName",
    value: function fieldName(index, id) {
      return "".concat(id, "-").concat(index);
    }
  }]);
}();
export default {
  bindings: {
    additionalItemPrompt: '<',
    addressStateProvinceRegionCodes: '<',
    onSelectionChanged: '&',
    taxAssociationCodes: '<',
    taxExemptionTypes: '<',
    taxLevelCodes: '<'
  },
  controller: TaxExemptionDetailsController,
  controllerAs: 'taxExemptionDetailsController',
  require: {
    formCtrl: '^form',
    ngModel: 'ngModel'
  },
  template: require('./tax.exemption.information.section.html')
};